import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import MUIAutocomplete from "src/components/GeneralComponents/MUIAutocomplete";
import {
  move_programmes_to_folder,
  programmeListingForMove,
} from "src/DAL/Programme/Programme";

const MoveProgramme = ({
  modalData,
  folder_list,
  setModalOpen,
  reloadList,
}) => {
  const [program, setProgram] = useState([]);
  const [folderList, setFolderList] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [inputs1, setInputs1] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [isFormLoading, setIsFormLoading] = useState(false);

  const programsList = async (value) => {
    const result = await programmeListingForMove(value._id);
    if (result.code == 200) {
      setProgram(result.program);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormLoading(true);
    let postData = {
      current_folder_id: modalData?._id,
      target_folder_id: inputs1?._id,
      programme_id_array: inputs.map((item) => item._id),
    };
    const result = await move_programmes_to_folder(postData);
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      setIsFormLoading(false);
      setModalOpen(false);
      reloadList();
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsFormLoading(false);
    }
  };

  useEffect(() => {
    programsList(modalData);
  }, [modalData]);

  useEffect(() => {
    const filteredList = folder_list.filter(
      (folder) => folder._id !== modalData._id
    );
    setFolderList(filteredList);
  }, [folder_list, modalData]);

  return (
    <>
      <div className="mt-3">
        <MUIAutocomplete
          inputLabel="Select Programmes"
          multiple
          selectedOption={inputs}
          setSelectedOption={(e) => {
            setInputs(e);
          }}
          required
          optionsList={program}
          name="title"
        />
      </div>{" "}
      <div className="mt-3">
        <MUIAutocomplete
          inputLabel="Select Folder"
          selectedOption={inputs1}
          setSelectedOption={(e) => {
            setInputs1(e);
          }}
          required
          optionsList={folderList}
          name="name"
        />
      </div>
      <div className="mt-3 text-end">
        <Button
          type="button"
          onClick={(e) => {
            handleSubmit(e);
          }}
          variant="contained"
          color="primary"
          disabled={isFormLoading || !inputs1 || inputs.length === 0}
        >
          {isFormLoading ? "Loading..." : "Save"}
        </Button>
      </div>
    </>
  );
};

export default MoveProgramme;
